// extracted by mini-css-extract-plugin
module.exports = {"navArrow":"x5","navArrowSvg":"x6","wrapper":"x7","reverse":"x8"};